import { useTranslation } from 'react-i18next'

import { getFrequencyOptions } from '../../helpers'
import SelectInput from './SelectInput'

interface FrequencyInputProps {
  timeStart: Date
  value: string
  isEditMode?: boolean
  setFieldValue: (name: string, value: string) => void
}

const FrequencyInput = ({ timeStart, value, isEditMode, setFieldValue }: FrequencyInputProps) => {
  const { t } = useTranslation(['eventManagement'])
  const options = getFrequencyOptions(timeStart, t)
  const valueToDisplay = options.find((option) => option.value === value)
  return (
    <SelectInput
      columnSize={12}
      name="frequency"
      label={t('eventManagement:common.frequencyLabel')}
      options={options}
      value={valueToDisplay}
      setFieldValue={(name: string, e: { value: string }) => {
        setFieldValue(name, e.value)
      }}
      disabled={isEditMode}
    />
  )
}

export default FrequencyInput
